<div class="content-div">
  <p class="heading">Let’s start by setting up your profile!</p>
  <p class="description">
    These details help us personalize your experience.
  </p>
  <app-biq-button
    name="Get Started" 
    (buttonEmitter)="onClickStartBtn()"
  ></app-biq-button>
</div>